var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    // Color
    {
      'bg-popover-dark': _vm.colorScheme === 'dark',
      'bg-popover-light ': _vm.colorScheme === 'light',
    },
    'backdrop-blur-10',
    'will-change-auto',

    // Shape
    'rounded-xl',
    {
      'py-2': _vm.mode === 'toolbar' && _vm.iconsPerLine === 3,
      'py-1': _vm.mode === 'toolbar' && _vm.iconsPerLine === 1,
      'px-2': (_vm.mode === 'toolbarHorizontal' || _vm.mode === 'elementModifier') && _vm.iconsPerLine === 3,
      'px-1': (_vm.mode === 'toolbarHorizontal' || _vm.mode === 'elementModifier') && _vm.iconsPerLine === 1,
    },

    // Children positioning
    'flex',
    {
      'flex-col': _vm.mode === 'toolbar',
      'flex-row': _vm.mode === 'toolbarHorizontal' || _vm.mode === 'elementModifier',
    },
    'items-center',
    'justify-center',
    {
      'gap-2.5': _vm.iconsPerLine === 3 && !_setup.isTouch,
      'gap-2': _vm.iconsPerLine === 1 || (_vm.iconsPerLine === 3 && _setup.isTouch),
    },
  ]},_vm._l((_vm.secondaryMenus),function(secondaryMenu,index){return _c('div',{key:secondaryMenu.id,class:_vm.mode === 'toolbar' ? 'flex flex-col' : 'flex flex-row'},[_c('div',{class:_vm.mode === 'toolbar'
          ? [
              'grid',
              {
                'grid-cols-1': _vm.iconsPerLine === 1,
                'grid-cols-3': _vm.iconsPerLine === 3,
              },
              {
                'gap-1': _vm.iconsPerLine === 1,
                'gap-2.5': _vm.iconsPerLine === 3,
              },
              {
                'mx-1': _vm.iconsPerLine === 1,
                'mx-2.5': _vm.iconsPerLine === 3,
              },
            ]
          : [
              'grid',
              {
                'grid-rows-1 grid-flow-col': _vm.iconsPerLine === 1,
                'grid-rows-3 grid-flow-col': _vm.iconsPerLine === 3,
              },
              {
                'gap-1': _vm.iconsPerLine === 1,
                'gap-2.5': _vm.iconsPerLine === 3,
              },
              {
                'my-1': _vm.iconsPerLine === 1,
                'my-2.5': _vm.iconsPerLine === 3 && !_setup.isTouch,
                'my-2': _vm.iconsPerLine === 3 && _setup.isTouch,
              },
            ]},_vm._l((secondaryMenu.items),function(item){return _c(_setup.WhiteboardSecondaryMenuIcon,{key:item.id,attrs:{"is-selected":item.id === _vm.secondarySelectionIds[index],"color-scheme":_vm.colorScheme,"icon-name":item.iconName,"icon-color":secondaryMenu.id === 'color' || item.iconName === 'color'
            ? item.id
            : secondaryMenu.id === 'fill-style'
            ? _vm.secondarySelectionIds[0]
            : undefined,"selected-background-color":secondaryMenu.id === 'draw-tool' ? _vm.secondarySelectionIds[1] : undefined,"label":item.label},on:{"click":function($event){return _setup.handleSelection(item, secondaryMenu.id, $event)}}})}),1),_vm._v(" "),(index < _vm.secondaryMenus.length - 1)?_c(_setup.OzDivider,{key:`divider-${index}`,class:_vm.mode === 'toolbar'
          ? [
              'ms-1.5',
              'me-1.5',
              {
                'mt-2.5': _vm.iconsPerLine === 3,
                'mt-2': _vm.iconsPerLine === 1,
              },
            ]
          : [
              'mt-1.5',
              'mb-1.5',
              {
                'ms-2.5': _vm.iconsPerLine === 3 && !_setup.isTouch,
                'ms-2': _vm.iconsPerLine === 1 || (_vm.iconsPerLine === 3 && _setup.isTouch),
              },
            ],attrs:{"color-scheme":_setup.OzDividerColorScheme.Solid,"orientation":_vm.mode === 'toolbar' ? _setup.OzDividerOrientation.Horizontal : _setup.OzDividerOrientation.Vertical,"dark-mode":_vm.colorScheme === 'dark'}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }